import { lazy } from "react";

/* React.lazy that survives a deploy: when a chunk 404s because the bundle changed under an open tab, reload once */
export const lazyRetry = (importer) => lazy(() =>
  importer().then((m) => { sessionStorage.removeItem("dgl_chunk_retry"); return m; }).catch((err) => {
    if (!sessionStorage.getItem("dgl_chunk_retry")) {
      sessionStorage.setItem("dgl_chunk_retry", "1");
      window.location.reload();
      return new Promise(() => {});
    }
    throw err;
  })
);
